import { Component, Injector, OnInit, forwardRef } from '@angular/core';
import { AttributeTypes } from 'src/global-variables';
import { BaseProductFieldComponent } from '../base-product-component/base-product-field.component';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  selector: 'app-product-field-boolean',
  templateUrl: './product-field-boolean.component.html',
  styleUrls: ['./product-field-boolean.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductFieldBooleanComponent),
      multi: true,
    },
  ],
})
export class ProductFieldBooleanComponent
  extends BaseProductFieldComponent
  implements ControlValueAccessor, OnInit
{
  constructor(injector: Injector) {
    super(injector);
  }
  control: FormControl;
  onChange: any = (value: boolean) => {};
  onTouch: any = () => {};
  value = false;
  writeValue(controlValue: any): void {
    if (typeof controlValue === 'string') {
      controlValue = controlValue.toLowerCase();
    } else {
      controlValue = controlValue?.toString();
    }
    const value = controlValue === 'y' || controlValue == 'true';
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  valueChanged(value: boolean) {
    this.onChange(value);
  }
}
